
import { Injectable, InjectionToken, Inject, Injector} from '@angular/core';
import { UserService } from 'src/app/service/user-service';
import { User } from 'src/app/model/user';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { UserDao } from 'src/app/dao/user-dao';
import { UserWebResponse } from 'src/app/model/user-web-response';


const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
const apiUrl = 'https://jsonplaceholder.typicode.com/posts/42';

@Injectable({
    providedIn: 'root'
})
export class UserServiceImpl implements UserService {
    userDao: UserDao = this.injector.get(UserDao);
    constructor(private injector: Injector,private http:HttpClient) {}

    getUser(): any {
        return this.userDao.getUser();
        // const u: User = new User();
        // u.name = 'David';

        // return u;
    }

    getUserList(): Observable<any> {
        return this.userDao.getUserList();
    }
    
    addUser(user): Observable<any> {
        console.log(user);
        return this.userDao.addUser(user);
    }
    editUser(user): Observable<any> {
        console.log(user);
        return this.userDao.editUser(user);
    }
    editProfile(user): Observable<any> {
        console.log(user);
        return this.userDao.editProfile(user);
    }
    editPassword(user): Observable<any> {
        console.log(user);
        return this.userDao.editPassword(user);
    }
    getUserAPI(user): Observable<any> {
        console.log(user);
        return this.userDao.getUserAPI(user);
    }
    getPhoto(): Observable<any> {
        return this.userDao.getPhoto();
    }
    editPhoto(file): Observable<any> {
        return this.userDao.editPhoto(file);
    }
    getTestUser(): Observable<any> {
        return this.userDao.getTestUser();
    }
    login(user): Observable<any> {
        return this.userDao.login(user).pipe(
            map(userWebResponse => {
                console.log(userWebResponse.success);
                if ( userWebResponse.success === true ) {
                    return new User(userWebResponse.data);
                }
                else {
                    return false;
                }
            })
        );
    }

    getLoginUser(user_id): Observable<any> {
        return this.userDao.getLoginUser(user_id).pipe(
            map(userWebResponse => {
                //console.log(userWebResponse.success);
                if ( userWebResponse.success === true ) {
                    return new User(userWebResponse.data);
                }
                else {
                    return false;
                }
            })
        );
    }

    getMapList(filtering,map_access_token): Observable<any> {
        return this.userDao.getMapList(filtering,map_access_token).pipe(
            map(userWebResponse => {
                return userWebResponse;
            })
        );
    }

    forgotpassword(user): Observable<any> {
        return this.userDao.forgotpassword(user).pipe(
            map(userWebResponse => {
                console.log(userWebResponse.success);
                return  userWebResponse.success;
            })
        );
    }
    logout(user): Observable<any> {
        console.log(user);
        return this.userDao.logout(user);
    }

    private handleError<T> (operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
      
          // TODO: send the error to remote logging infrastructure
          console.error(error); // log to console instead
      
          // TODO: better job of transforming error for user consumption
          console.log(`${operation} failed: ${error.message}`);
      
          // Let the app keep running by returning an empty result.
          return of(result as T);
        };
      }

}

// export const UserServiceProvider = new InjectionToken(
//     'UserServiceProvider',
//     { providedIn: 'root', factory: () => new UserServiceImpl(@Inject(ENV) private environment) }
// );
